import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { CampaignContentVersionSource } from '../../constants/campaign-sequence';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { CampaignContentEntity } from './campaign-content.entity';

/**
 * PD-17613 — every version of a piece of campaign copy, for the version
 * history and restore. A row is written each time the content's wording
 * changes (drafted, regenerated, edited, restored). Not auditable: the rows
 * are themselves the history.
 */
@Index('campaign_content_version__content_version', ['fkCampaignContentId', 'versionNo'], { unique: true })
@Entity('campaign_content_version', {}, { auditable: false })
export class CampaignContentVersionEntity extends BaseEntity {
	@Column('int', { name: 'fk_campaign_content__id', unsigned: true })
	public fkCampaignContentId!: number;

	@Column('int', { name: 'versionNo', unsigned: true })
	public versionNo!: number;

	@Column('varchar', { name: 'subjectA', length: 500, nullable: true })
	public subjectA!: string | null;

	@Column('varchar', { name: 'subjectB', length: 500, nullable: true })
	public subjectB!: string | null;

	@Column('text', { name: 'body', nullable: true })
	public body!: string | null;

	// App-validated (CampaignContentVersionSource).
	@Column('varchar', { name: 'source', length: 20 })
	public source!: CampaignContentVersionSource | string;

	@ManyToOne(() => CampaignContentEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_campaign_content__id', referencedColumnName: 'id' }])
	public fkCampaignContent!: CampaignContentEntity;
}
